module.exports = __webpack_public_path__ + "img/1448857756.6d047799.jpg";